"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _DomHelper = require("../../utils/DomHelper");
var _StringHelpers = _interopRequireWildcard(require("../../utils/StringHelpers"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// const baseApiURLs = 'https://i-api.eon.de/cscn-customer-srv';
var data = (0, _DomHelper.getIdDataset)('cscn-config', 'props');
var cscConfig = data ? JSON.parse((0, _StringHelpers.default)((0, _DomHelper.getIdDataset)('cscn-config', 'props'))) : null;
var cicDomains = (0, _DomHelper.getIdDataset)('KUNDENPORTAL_MW_URL', 'cicMiddlewareDomains') || '{}';
var cscnCustomerDomain = (0, _DomHelper.getIdDataset)('KUNDENPORTAL_MW_URL', 'cscnMiddlewareCustomerDomain');
var cscnAccountDomain = (0, _DomHelper.getIdDataset)('KUNDENPORTAL_MW_URL', 'cscnMiddlewareAccountDomain');
var noDoiDSO = ['ENB', 'EVP', 'AHN', 'ENS', 'NNNG', 'ELBE'];
// The functionality is disabled for now
// export const isDoiDSO = (DSO) => !noDoiDSO.includes(DSO);

var CONFIG = {
  GA_TRACKING_ID: 'XXXXXXXXX',
  GA_TRACKING_DEBUG: false,
  GA_ENABLED: false,
  ACTION_TYPES: {},
  CHANNEL_CONFIG: {
    anonymMR: 'ANONYMOUSMETERREADING',
    loggedInCsc: 'CSC',
    portal: 'PORTAL',
    postalAuth: 'ANONYMOUSINTERIMMETERREADING'
  },
  AEM_CONFIG: _objectSpread(_objectSpread({
    cscConfigAdded: !!cscConfig
  }, cscConfig), {}, {
    // TODO: remove the hardcoded value once the AEM config is available
    autologoutLandingPage: '/de/service/logout.html',
    isDkePage: (0, _DomHelper.getInputValueIfExists)('dke-page') === 'true',
    isAuthorMode: (0, _DomHelper.getInputValueIfExists)('author_mode') !== null,
    middlewareDomains: _objectSpread(_objectSpread({}, JSON.parse(cicDomains)), {}, {
      cscnCustomerDomain: cscnCustomerDomain,
      cscnAccountDomain: cscnAccountDomain
    })
  })
};
var _default = exports.default = CONFIG;